<div mat-dialog-title>Detaljer</div>
<mat-dialog-content>
  <div class="holder">{{ data }}</div>
</mat-dialog-content>
<mat-dialog-actions>
  <button
          mat-dialog-close
          matButton="filled"
  >Stäng
  </button>
</mat-dialog-actions>


